<template>
    <div class="text-center font-Inter px-2.5">
        <h2 class="text-won-blue text-[30px] leading-[36px] font-bold">
            Need a Professional Resume?
        </h2>

        <p class="text-center text-[14px] leading-[17px] text-[#444C58] mt-4 tracking-[2%] font-medium">
            We can write your resume for you! <br/>
            Our clients have landed jobs at Google, Microsoft, Tesla and other top Fortune 500 companies. Let our career consultants create your resume today!
        </p>

        <div class="mt-11">
            <p class="italic !text-left font-semibold text-[13px] leading-[16px] tracking-[2%] text-won-dark-blue">
                "Wonsulting really tailored my resume and highlighted my strengths. They added a lot of metrics and facts into my resume and made my achievements sound more substantial. I was offered many interviews at large corporations and eventually landed a job at Yelp!"
            </p>

            <div class="flex items-center gap-2.5 text-left mt-6 font-semibold w-fit mx-auto">
                <div class="rounded-full overflow-hidden w-10 h-10">
                    <img src="/img/jonathan-budning.webp" alt="Jonathan Budning" class="w-auto h-full object-cover">
                </div>
                
                <div>
                    <span class="block text-won-dark-blue text-[19px] leading-[23px]">Jonathan Budning</span>
                    <span class="block mt-0.5 text-[#929497] text-[12px] leading-[14px]">Engineering Manager at Yelp</span>
                </div>
            </div>
        </div>

        <div class="mt-20 mb-5 text-[16px] leading-[19px]">
            <button
                class="text-white bg-won-green rounded py-[9px] px-[77px]"
                @click="() => serviceNudgesStore.nudgeCtaClickHandler(serviceNudgesStore.FEATURES.resumeAi)"
            >
                LET US WRITE YOUR RESUME
            </button>
        </div>
    </div>
</template>

<script setup>
import { useServicesNudges } from '../../../store/services-nudges.store';

const serviceNudgesStore = useServicesNudges();
</script>